import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideMarkdown } from 'ngx-markdown';
import { CommonModule } from '@angular/common';
import { GlobalErrorHandlerService } from './common/global-error-handler.service';
import { AuthService } from './services/auth/auth.service';
import { HttpErrorInterceptor } from './common/http-error.interceptor';
import { ApiAuthInterceptor } from './common/api-auth.interceptor';
import { TestBenchModule } from './test-bench/test-bench.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(
      // DI-based interceptors must be explicitly enabled in angular 19+.
      withInterceptorsFromDi()
    ),
    provideMarkdown(),
    // Use the custom route reuse strategy
    // { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    importProvidersFrom(CommonModule, AuthService, TestBenchModule),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    // does not work when using fetch() instead of http client, handle those errors in the service
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiAuthInterceptor, multi: true },
    provideAnimationsAsync(),
  ],
};
